import { useQuery } from "@tanstack/react-query";
import { BosDurum, Buton, Iskelet, Kart, Rozet } from "@koclukpanel/ui";
import { ApiHatasi, personelTekil } from "../api";

/**
 * PERSONEL GENEL BAKIŞ — Personel 360°
 *
 * ================================================================
 * T.C. KİMLİK HAM HÂLİYLE HİÇ GELMİYOR
 * ================================================================
 * Sunucu yalnızca maskeli hâli döndürüyor (`•••••••••46`). Ham
 * gönderip burada maskeleseydik numara ağ trafiğinde, tarayıcı
 * belleğinde ve geliştirici araçlarında görünür olurdu; ekranda
 * maskeli görünmesi bunu değiştirmezdi.
 *
 * Son iki hane "hangi kayıt" sorusunu cevaplıyor — ayırt etmeye yeter,
 * kimlik doğrulamaya yetmez.
 */

const DURUM_ADI: Record<string, string> = {
  ACTIVE: "Aktif",
  INVITED: "Davet edildi",
  PASSIVE: "Pasif",
  SUSPENDED: "Donduruldu",
  LOCKED: "Kilitli",
};

function Satir({ ad, deger }: { ad: string; deger: React.ReactNode }) {
  return (
    <div className="border-notr-200 flex flex-wrap items-baseline justify-between gap-2 border-b py-2 last:border-b-0">
      <dt className="text-notr-600 text-sm">{ad}</dt>
      <dd className="text-notr-900 text-sm">{deger}</dd>
    </div>
  );
}

export function GenelBakis({ personelId }: { personelId: string }) {
  const veri = useQuery({
    queryKey: ["personel-tekil", personelId],
    queryFn: () => personelTekil(personelId),
    retry: false,
  });

  if (veri.isPending) return <Iskelet satir={4} />;

  if (veri.isError) {
    return (
      <Kart baslik="Genel bakış">
        <BosDurum
          ton="hata"
          baslik="Kayıt alınamadı"
          aciklama={veri.error instanceof ApiHatasi ? veri.error.message : undefined}
          eylem={
            <Buton gorunum="ikincil" onClick={() => void veri.refetch()}>
              Tekrar dene
            </Buton>
          }
        />
      </Kart>
    );
  }

  const p = veri.data;

  return (
    <Kart baslik="Genel bakış">
      <dl className="flex flex-col">
        <Satir ad="Ad soyad" deger={`${p.firstName} ${p.lastName}`} />
        <Satir ad="E-posta" deger={p.email} />
        <Satir ad="Telefon" deger={p.phone ?? "—"} />
        {/*
          MASKELİ hâl geliyor; ham numara sunucudan hiç çıkmıyor.
          "—" burada "kayıtlı değil" demek, "gizlendi" değil.
        */}
        <Satir ad="T.C. kimlik" deger={p.nationalIdMaskeli ?? "—"} />
        <Satir
          ad="Durum"
          deger={
            <Rozet ton={p.status === "ACTIVE" ? "onay" : "uyari"}>
              {DURUM_ADI[p.status] ?? p.status}
            </Rozet>
          }
        />
        <Satir
          ad="Roller"
          deger={
            p.roller.length === 0 ? (
              /*
                ROLSÜZ PERSONEL BİR ARIZA, boş bir alan değil: hesabı
                var ama hiçbir şey yapamıyor. Sessizce boş bırakmak,
                "neden hiçbir ekranı açamıyorum" sorusunu cevapsız
                bırakırdı.
              */
              <Rozet ton="uyari">Rol atanmamış</Rozet>
            ) : (
              <span className="flex flex-wrap justify-end gap-1">
                {p.roller.map((r) => (
                  <Rozet key={r} ton="notr">
                    {r}
                  </Rozet>
                ))}
              </span>
            )
          }
        />
        {p.archivedAt && (
          <Satir ad="Arşivlendi" deger={new Date(p.archivedAt).toLocaleDateString("tr-TR")} />
        )}
      </dl>
    </Kart>
  );
}
